import { useCallback } from 'react';
import { useAppDispatch } from '../grid/reduxStore/Store';
import { useSocketClient } from '../../../providers/SocketContext';
import { useCurrentUser } from '../../../providers/UserProvider';
import { useCheckDocumentLockStatus } from 'components/editor/hooks/useCheckDocumentLockStatus';
import { UndoRedoManagerCommandVersion } from '../UndoRedo/UndoRedoManagerCommandVersion';
import { SignatureReassignCommand } from '../UndoRedo/SignatureReassignCommand';
import type { AssignedSignee } from '../../../services/entities/SignatureTypes';

export function useSignatureReassignHandler() {
  const dispatch = useAppDispatch();
  const { socketClient } = useSocketClient();
  const { data } = useCurrentUser();
  const checkDocumentLockStatus = useCheckDocumentLockStatus();
  const userId = data.id;

  return useCallback(
    async (blockId: string, sectionId: string, oldSignee: AssignedSignee | null, newSignee: AssignedSignee | null) => {
      const undoRedoManager = UndoRedoManagerCommandVersion.getUndoRedoManager();
      const command = new SignatureReassignCommand(blockId, sectionId, oldSignee, newSignee, {
        dispatch,
        socketClient,
        userId,
        checkDocumentLockStatus,
      });
      const success = await command.redo();
      if (success) {
        undoRedoManager.pushUndoRedoCommands(command);
      }
    },
    [dispatch, socketClient, userId, checkDocumentLockStatus]
  );
}
